// Fix stale CDN variant availability for MILLIONVVV
(function() {
  if (!window.location.pathname.includes('/products/')) return;
  var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
  if (!handle) return;

  function applyFix(product) {
    var availMap = {};
    product.variants.forEach(function(v) { availMap[v.id] = v.available; });

    // Hide sold-out badge if product has availability
    if (product.available) {
      document.querySelectorAll('.price__badge-sold-out').forEach(function(b) {
        b.classList.add('hidden');
      });
    }

    // Patch each variant picker web component
    document.querySelectorAll('variant-selects, variant-radios').forEach(function(picker) {
      // Update the JSON script so cache re-read gets correct data
      var jsonScript = picker.querySelector('script[type="application/json"]');
      if (jsonScript) {
        try {
          var variants = JSON.parse(jsonScript.textContent);
          if (Array.isArray(variants)) {
            variants.forEach(function(v) {
              if (availMap[v.id] !== undefined) v.available = availMap[v.id];
            });
            jsonScript.textContent = JSON.stringify(variants);
          }
        } catch(e) {}
      }
      // Clear Dawn's cache so it re-reads updated JSON
      picker.variantDataCache = null;

      // Trigger re-render via change event on current selection
      var sel = picker.querySelector('input:checked, select');
      if (sel) sel.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }

  // Fetch fresh data then apply — run after page load to ensure Dawn has initialized
  window.addEventListener('load', function() {
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(applyFix)
      .catch(function(e) { console.warn('[MVVV] fix error:', e); });
  });
})();